import {
  AfterViewInit,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { NzNotificationRef, NzNotificationService } from 'ng-zorro-antd/notification';
import { IconComponent } from '../icon/icon.component';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'adspt-toaster',
  templateUrl: './toaster.component.html',
  styleUrl: 'toaster.component.scss',
  imports: [IconComponent, NzButtonComponent, TranslatePipe],
})
export class ToasterComponent implements AfterViewInit {
  private notification = inject(NzNotificationService);
  readonly title = input<string>();
  readonly placement = input<'bottomLeft' | 'bottomRight'>('bottomLeft');
  readonly duration = input<number>();
  readonly action = input<() => unknown>();
  readonly actionTxt = input<string>();
  readonly type = input<'success' | 'info' | 'warning' | 'error' | 'blank' | string>();
  readonly icon = computed(() => {
    switch (this.type()) {
      case 'success':
        return 'check-circle';

      case 'error':
        return 'close-circle';

      case 'warning':
        return 'alert-triangle';

      case 'info':
        return 'alert-info';

      default:
        return null;
    }
  });

  readonly closed = output<boolean>();

  readonly template = viewChild(TemplateRef);

  readonly toastRef = signal<NzNotificationRef>(null);

  ngAfterViewInit() {
    const toastInstance = this.notification.template(this.template(), {
      nzPlacement: this.placement(),
      nzDuration: this.duration() || 15000,
      nzPauseOnHover: true,
      nzAnimate: true,
      nzClass: `adspt-toast ${this.type()}`,
      nzCloseIcon: 'cross',
    });

    this.toastRef.set(toastInstance);

    toastInstance.onClose.subscribe(() => {
      this.toastRef.set(null);
      this.closed.emit(true);
    });
  }

  onActionClick(): void {
    this.action()?.();
    this.notification.remove(this.toastRef()?.messageId);
  }
}
